import { Box } from '@mantine/core'
import { SelectOptionCard } from '../../select-option-card/select-option-card'

import type { OpportunityFormSingleOrSeriesStepProps } from './opportunity-form-single-or-series-step.types'
import styles from './opportunity-form-single-or-series-step.module.scss'

export function OpportunityFormSingleOrSeriesStep({
  value,
  onChange,
  singleEventTitle,
  singleEventDescription,
  eventSeriesTitle,
  eventSeriesDescription,
}: Readonly<OpportunityFormSingleOrSeriesStepProps>) {
  return (
    <Box className={styles.OptionsCardsBox}>
      <SelectOptionCard
        testId="singleEvent"
        title={singleEventTitle}
        description={singleEventDescription}
        active={!value}
        onClick={() => onChange(false)}
      />
      <SelectOptionCard
        testId="eventSeries"
        title={eventSeriesTitle}
        description={eventSeriesDescription}
        active={value}
        onClick={() => onChange(true)}
      />
    </Box>
  )
}
